/**
 * <gift-selector> — a thin wrapper around a native <product-form-component> that
 * lets a shopper pick ONE free-gift variant from a radio group before adding it
 * to the cart.
 *
 * The actual add-to-cart + offer handling is done entirely by the theme-native
 * product-form-component (which reads the checked radio via FormData `id` and
 * runs the store offer engine). This element only:
 *   1. enables the add-to-cart button once a gift is chosen, and
 *   2. mirrors the chosen variant into the product-form `variantId` ref so the
 *      component's ancillary variant/discount logic stays in sync.
 *
 * No third-party dependencies — native custom element per the theme style guide.
 */
class GiftSelector extends HTMLElement {
  connectedCallback() {
    this.variantIdInput = this.querySelector('[ref="variantId"]');
    this.addToCartButton = this.querySelector('[ref="addToCartButton"]');
    this.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  handleChange = (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'id') return;

    const selected = this.querySelector('input[name="id"]:checked');
    if (!selected) return;

    if (this.variantIdInput instanceof HTMLInputElement) {
      this.variantIdInput.value = selected.value;
    }
    if (this.addToCartButton instanceof HTMLButtonElement) {
      this.addToCartButton.disabled = false;
    }
  };
}

if (!customElements.get('gift-selector')) {
  customElements.define('gift-selector', GiftSelector);
}
